import React from "react";
import "../../styles/global.css";

const AdminFormField = ({
  label,
  type = "text",
  value,
  onChange,
  error,
  helperText,
  placeholder,
  step,
  required,
  ...props
}) => {
  return (
    <div className="admin-form-group">
      {label && (
        <label className="form-label">
          {label}
          {required && <span style={{ color: "#e00", marginLeft: 4 }}>*</span>}
        </label>
      )}
      <input
        type={type}
        className={`form-control ${error ? "invalid" : ""}`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        step={step}
        required={required}
        {...props}
      />
      {error && <div className="text-danger" style={{ fontSize: 12, marginTop: 4 }}>{error}</div>}
      {helperText && !error && (
        <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default AdminFormField;

